import React, { FC, useContext } from "react";
import { FormattedMessage } from "react-intl-phraseapp";
import { Biosimilar } from "../../../../@types";
import {
  AnalyticsActionType,
  Ga4Event,
  Ga4EventType,
} from "../../../../app/contexts/Analytics/types";
import { AppContext } from "../../../../app/store";
import {
  HelpDrawerWrapper,
  InterchangeableBiologicsIcon,
} from "../../../../components";
import { useTranslate } from "../../../../helpers";
import * as messages from "../../../../translations/en-US.json";

export const biosimilarTestIdPrefix = "biosimilar-test-id-";

const drawerLinkTextKey = "interchangeable_biologic.help_drawer.link_text";
const drawerToggleKey = "interchangeable_biologic.help_drawer.toggle_text";
const drawerLinkUrlKey = "interchangeable_biologic.help_drawer.link";

export const InterchangeableBiologicsHelpDrawer: FC<{
  displayDrugString: string;
  interchangeableBiologics: Biosimilar[];
}> = ({ displayDrugString, interchangeableBiologics, ...props }) => {
  const t = useTranslate();
  const { dispatch } = useContext(AppContext);
  const mct_biosimilar_drug_name = interchangeableBiologics
    .map(ib => ib.displayName)
    .join(", ");
  const sendDrawerOpenedAnalytics = () => {
    dispatch({
      type: AnalyticsActionType.SEND_GA4_EVENT,
      settings: {
        event_name: Ga4Event.BIOSIMILAR_LINK_CLICKED,
        event_type: Ga4EventType.UI_INTERACTION,
        link_text: messages[drawerToggleKey],
        mct_biosimilar_reference_drug_name: displayDrugString,
        mct_biosimilar_drug_name,
      },
    });
    dispatch({
      type: AnalyticsActionType.SEND_TEALIUM_EVENT,
      settings: {
        event_action: "biosimilar link clicked",
        event_label: displayDrugString,
      },
    });
  };
  const sendDrawerLinkAnalytics = () => {
    dispatch({
      type: AnalyticsActionType.SEND_INTERNAL_LINK_CLICKED_EVENT,
      settings: {
        linkText: messages[drawerLinkTextKey],
        linkUrl: messages[drawerLinkUrlKey],
        custom: {
          mct_biosimilar_reference_drug_name: displayDrugString,
          mct_biosimilar_drug_name,
          link_text: `biosimilar: ${messages[drawerLinkTextKey]}: ${messages[drawerLinkUrlKey]}`,
        },
      },
    });
  };
  return (
    <HelpDrawerWrapper
      toggleText={
        <>
          <InterchangeableBiologicsIcon className="ds-u-margin-right--05 ds-u-valign--top" />
          {t("interchangeable_biologic.help_drawer.toggle_text")}
        </>
      }
      drawerTitle={t("interchangeable_biologic.help_drawer.heading")}
      toggleClassName="ds-u-text-align--left ds-u-border--0 ds-u-margin-top--1"
      onOpenDrawer={sendDrawerOpenedAnalytics}
      {...props}
    >
      <FormattedMessage
        id="interchangeable_biologic.help_drawer.coverage_explanation"
        values={{
          reference_drug: displayDrugString,
        }}
        tagName="p"
      />
      <ul>
        {interchangeableBiologics.map(ib => (
          <li
            key={ib.rxcui}
            data-testid={`${biosimilarTestIdPrefix}${ib.rxcui}`}
          >
            {ib.displayName}
          </li>
        ))}
      </ul>
      <p>{t("interchangeable_biologic.help_drawer.disclaimer")}</p>
      <p>
        <a
          target="_blank"
          rel="noreferrer"
          href={t(drawerLinkUrlKey)}
          onClick={sendDrawerLinkAnalytics}
        >
          {t(drawerLinkTextKey)}
        </a>
      </p>
    </HelpDrawerWrapper>
  );
};
